export const generateRandomString = (length = 64) => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
};

export const toLocalDatetimeString = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const parseDatetimeLocalToUTC = (localDateStr: string | Date): Date => {
  const date = new Date(localDateStr as any);
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset()); // offset về UTC
  return date;
};

// Ngược lại của parseDatetimeLocalToUTC: Date theo quy ước "giờ tường ép vào UTC" (khi
// JSON.stringify sẽ ra đúng giờ tường kèm Z, server lưu nguyên giá trị) -> chuỗi
// "YYYY-MM-DDTHH:mm". Đọc bằng getter LOCAL (toLocalDatetimeString) là dôi đúng 1 múi giờ.
export const toUtcDatetimeString = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return (
    `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}` +
    `T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
  );
};

// "YYYY-MM-DDTHH:mm" (chuỗi kiểu ô datetime-local) -> "DD/MM/YYYY HH:mm" (chuỗi DateInput hiển thị).
export const datetimeLocalToDdMm = (s: string) =>
  s && s.length >= 16
    ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)} ${s.slice(11, 16)}`
    : "";

export function formatDateISO(date: Date): string {
  const utcDate = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
  return utcDate.toISOString();
}

// Chuỗi ISO GIỮ NGUYÊN GIỜ ĐỊA PHƯƠNG (không quy về UTC như formatDateISO) — dùng cho các
// bộ lọc có nhập giờ: 07:00 giờ Việt Nam qua formatDateISO thành 00:00, lọc sai hẳn một buổi.
export function formatDateTimeISO(date: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}` +
    `T${p(date.getHours())}:${p(date.getMinutes())}:00`
  );
}

export function timeAgo(input: string | Date): string {
  const now = new Date();
  const date = input instanceof Date ? input : new Date(input);

  if (isNaN(date.getTime())) return "";

  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) {
    return "vài giây trước";
  }

  if (diffMin < 60) {
    return `${diffMin} phút trước`;
  }

  if (diffHour < 24) {
    return `${diffHour} giờ trước`;
  }

  if (diffDay <= 2) {
    return `${diffDay} ngày trước`;
  }

  const pad = (n: number): string => n.toString().padStart(2, "0");

  return (
    `${pad(date.getHours())}:${pad(date.getMinutes())} ` +
    `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
  );
}

export const detectType = (value: any): "date" | "number" | "string" => {
  if (value === null || value === undefined) return "string";

  if (typeof value === "number" && !isNaN(value)) return "number";

  if (typeof value === "string") {
    const trimmed = value.trim();

    if (trimmed === "") return "string";

    const isISOFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(trimmed);

    if (isISOFormat) {
      const time = Date.parse(trimmed);
      if (!isNaN(time)) return "date";
    }

    if (!isNaN(Number(trimmed))) return "number";
  }

  return "string";
};
